import React from 'react'
import { useParallaxInView } from '../../lib/hooks'
import Content from '../block-content/block-content'
import { Section } from '../section/section.component'
import {
  base,
  containers,
  imageStyles,
  useScroll,
  useSpring,
  useInView,
  animations,
  motion,
} from '../../styles/base/_allBase.styles'
const { H3, StyleP, CenterDiv } = base
const { TwoColumnGrid, GridItem } = containers
const { ImgCover } = imageStyles
import { Container } from './contact-information.styles'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'

function ContactInfoSection({ data }) {
  const { y, ref, isInView } = useParallaxInView(50)
  const { title, description, address, email, phoneNumber } = data
  return (
    <Section
      style={{ zIndex: 0 }}
      cursorsize={'small'}
      size={'auto'}
      {...analyticsModuleAttributes(data, 'contact_information', undefined, title)}
    >
      <Container ref={ref}>
        <H3 color={'primary'} style={{ y }}>
          {title}
        </H3>
        <StyleP color={'primary'} style={{ y }}>
          <Content blocks={description} />
        </StyleP>
        <StyleP color={'primary'} style={{ y }}>
          <Content blocks={address} />
        </StyleP>
        <StyleP color={'primary'} style={{ y }}>
          Email: {email}
        </StyleP>
        {/* <StyleP color={'primary'} style={{ y }}>
					Call: {phoneNumber}
				</StyleP> */}
        <motion.div
          style={{ y, width: '100%' }}
          {...animations.headerTypography}
        >
          <a
            data-analytics-cta-id="contact-directions"
            data-analytics-cta-type="directions"
            data-analytics-cta-label="Google Maps"
            data-analytics-placement-id="contact-information"
            href={
              'https://www.google.com/maps/place/Selong+Belanak,+Praya+Barat,+Central+Lombok+Regency,+West+Nusa+Tenggara/@-8.86964,116.147831,14z/data=!3m1!4b1!4m6!3m5!1s0x2dcda7261d460c25:0x41ac184dd598973f!8m2!3d-8.8606802!4d116.1418515!16s%2Fg%2F15dqd333?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D'
            }
          >
            <StyleP color={'primary'} right>
              Google Maps
            </StyleP>
          </a>
        </motion.div>
      </Container>
    </Section>
  )
}

export { ContactInfoSection }
